module.exports = __webpack_public_path__ + "img/OPAL.1cf833a7.svg";